import RowItemListOrganizationPeriodical from './RowItemListOrganizationPeriodical.jsx';
import RowItemListProofReceptionPeriodical from './RowItemListProofReceptionPeriodical.jsx';
import RowItemListAttachReceptionPeriodical from './RowItemListAttachReceptionPeriodical.jsx';
export {
  RowItemListOrganizationPeriodical,
  RowItemListProofReceptionPeriodical,
  RowItemListAttachReceptionPeriodical
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/detail/index.js